<template>
	<div id="page-content">
		<!--<h3>The Map Goes Here</h3><p>API Key: AIzaSyCZlo9V1naHZqoJsXYBGkGXYgD53ERe5yo</p>-->
		<div id="map" style="
			height: 400px; 
			width: 100%; 
			background: #ccc;
			position: relative;
			">
		</div>

		<div id="searchbox">
			<input type="text" name="search" placeholder="search Apollo locations" id="search" @change="search" @keyup="search">
			<ul id="locationlist">
				<li v-for="location in locationlist" :lat="location.lat" :lng="location.lng" @click="center" v-text="location.name.toLowerCase()"></li>
			</ul>
		</div>
		
	</div>
</template>

<script>
	export default{
		data(){
			return{
				locationlist: []
			}
		},
		methods: {
			search: function(event){
				var self = this;
				var search = $(event.target).val().trim();
				// console.log(search);
				$.ajax({
					url: 'static/php/searchlocation.php',
					data: {search: search},
					type: 'POST',
					success: function(data){
						if(data === '' || JSON.parse(data).length === 0){
							self.locationlist = [];
						}else{
							data = JSON.parse(data);
							self.locationlist = data;
						}
					}
				});
			},

			center: function(event){
				var value = event.target.innerHTML;
				var lat = parseFloat(event.target.getAttribute('lat'));
				var lng = parseFloat(event.target.getAttribute('lng'));
				$('#search').val(value);
				map.panTo({
					lat : lat,
					lng : lng
				});
				$('#locationlist').html('');
			}
		},
		created(){
			
		},
		mounted(){
			relativeTo('nav', this.$el);
			initMap();
		}
	}
</script>


// WEBPACK FOOTER //
// Locations.vue?a7c43462